<template>
<div class="post-purchase">
  <h1>{{__('Thank you!')}}</h1>
  <p v-if="paymentOption === 'klarna'">
    {{__('We have received your order and will keep you informed on when delivery takes place.')}}
  </p>
  <p v-else>
    {{__('We have received your order and will email you an invoice and keep you informed on when delivery takes place.')}}
  </p>
  <p>{{__('Best regards,')}}
  <br>
  <b>{{__('The RideQ Team')}}</b></p>
</div>
</template>
<script>

export default {
  name: 'PostPurchasePage',
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    paymentOption () {
      return this.$store.getters.paymentOption
    }
  }
}

</script>
<style lang="less" scoped>
  @import '../style/variables.less';

  .post-purchase {
    width: 400px;
    max-width: 100%;
    position: relative;
    margin: auto;
    left: auto;
    right: auto;

    h1, p {
      width: 100%;
      text-align: center;
    }
  }
</style>
